module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0bc0d8117635d3a49cdda39c562ca88f.png";